// src/Components/Tournaments/TournamentDetails.jsx
import React, { useEffect, useState} from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { IoHome } from "react-icons/io5";
import { PiKeyReturnFill } from "react-icons/pi";
import { toast } from 'react-toastify';
import { useAuth } from "../../Context/AuthContext";
import TournamentTabs from "./TournamentTabs";
import "./TournamentDetails.css";

const API = process.env.REACT_APP_API;

const TournamentDetails = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const { user } = useAuth();

  const [tournament, setTournament] = useState(null);
  const [selectedEvent, setSelectedEvent] = useState(null);

  // טאבים של אילת
  const [tournamentsList, setTournamentsList] = useState([]);
  const [selectedTournamentForTabs, setSelectedTournamentForTabs] = useState(null);

  const isEilatTournament = tournament?.type === "eilat" || tournament?.name?.includes("אילת");

  useEffect(() => {
    if (!slug) return;

    const fetchTournament = async () => {
      try {
        const res = await axios.get(`${API}/api/tournaments/slug/${slug}`);
        setTournament(res.data);

        if (isEilatTournament) {
          const { data } = await axios.get(`${API}/api/eilatTournaments`);
          const sorted = data.sort((a,b)=> new Date(b.year) - new Date(a.year));
          setTournamentsList(sorted);

          // בחר את הטורניר עם האירוע ברירת המחדל שהוגדר
          const defaultTournament = sorted.find(t => t.defaultEventId) || sorted[0];
          setSelectedTournamentForTabs(defaultTournament);

        }
      } catch (err) {
        console.error(err);
        toast.error("טעינת הטורניר נכשלה");
      }
    };

    fetchTournament();
  }, [slug, isEilatTournament]);

  if (!tournament) return <p>טוען...</p>;

  const registrationButton = (event) => {
  if (!event || !event.showRegistration) return null;
  const link = event.registrationLink?.trim();
  if (link) return <a href={link} target="_blank" rel="noreferrer" className="btn">הרשמה</a>;
  return <button className="btn disabled" disabled>הרשמה</button>;
};

const facebookButton = (event) => {
  if (!event || !event.showFacebook) return null;
  const link = event.facebookLink?.trim();
  if (link) return <a href={link} target="_blank" rel="noreferrer" className="btn facebook">פייסבוק</a>;
  return <button className="btn disabled" disabled>פייסבוק</button>;
};


  return (
    <div className="daily-tournaments">

      <div className="home-icon">
        <IoHome size={30} onClick={() => navigate("/")} />
      </div>
      <div className="back-icon">
        <PiKeyReturnFill size={40} onClick={() => navigate("/tournaments")} />
      </div>

      {isEilatTournament ? (
        <div className="eilat-tournament-page">
          {/* פרטי הטורניר הנבחר */}
          <main className="tournament-details">
            <h2>{selectedTournamentForTabs?.name}</h2>

            {selectedTournamentForTabs?.showFlyer && selectedTournamentForTabs?.flyer && (
              <img src={selectedTournamentForTabs.flyer} alt="פלייר" className="flyer" />
            )}

            <div className="tournament-actions">
              {registrationButton(selectedTournamentForTabs)}
              {facebookButton(selectedTournamentForTabs)}
            </div>

            {selectedTournamentForTabs?.showGallery && selectedTournamentForTabs?.gallery?.length > 0 && (
              <div className="gallery">
                {selectedTournamentForTabs.gallery.map((img,i) => (
                  <img key={i} src={img.url || img} alt={`תמונה ${i}`} />
                ))}
              </div>
            )}
          </main>

          {/* טאבים מתחת לפרטי הטורניר */}
          <TournamentTabs
            tournaments={tournamentsList}
            selectedId={selectedTournamentForTabs?._id}
            onSelect={(id) => {
              const t = tournamentsList.find(t => t._id === id);
              setSelectedTournamentForTabs(t);
            }}
          />
        </div>
      ) : (
        <div className="daily-tournaments">
          {/* צד ימין – רשימת אירועים */}
          <aside className="tournament-list">
            <h3>{tournament.name}</h3>

            {user?.isAdmin && (
              <button className="btn add-btn" onClick={() => navigate(`/tournaments/${slug}/events/new`)}>
                ➕ הוספת אירוע
              </button>
            )}

            {tournament.events?.length === 0 ? (
              <p className="no-events">אין אירועים בינתיים</p>
            ) : (
              <ul>
                {tournament.events
                  .filter(e => user?.isAdmin || e.showOnSite)
                  .sort((a, b) => new Date(a.date) - new Date(b.date))
                  .map(event => (
                    <li
                      key={event._id}
                      className={`tournament-list ${selectedEvent?._id === event._id ? "selected" : ""}`}
                      onClick={() => setSelectedEvent(event)}
                    >
                      {event.name} – {new Date(event.date).toLocaleDateString("he-IL")}
                    </li>
                  ))}
              </ul>
            )}
          </aside>

          {/* צד שמאל – פרטי האירוע */}
          <main className="tournament-details">
            {!tournament.events?.length ? (
              <p className="center-message">אין אירועים בינתיים</p>
            ) : !selectedEvent ? (
              <p className="no-event-selected">נא לבחור אירוע להצגה</p>
            ) : (
              <>
                <h3>{selectedEvent.name}</h3>
                <p>{new Date(selectedEvent.date).toLocaleDateString("he-IL")}</p>

                {selectedEvent.showFlyer && selectedEvent.flyer && (
                  <img src={selectedEvent.flyer} alt={selectedEvent.name} className="flyer" />
                )}

                <div className="tournament-actions">
                  {registrationButton(selectedEvent)}
                  {facebookButton(selectedEvent)}
                </div>

                {selectedEvent.gallery?.length > 0 && (
                  <div className="gallery">
                    {selectedEvent.gallery.map((img, i) => (
                      <img key={i} src={img} alt="gallery" />
                    ))}
                  </div>
                )}

                {user?.isAdmin && (
                  <>
                    <p className="status">
                      סטטוס: {selectedEvent.showOnSite ? "✅ מוצג למבקרים" : "❌ מוסתר ממבקרים"}
                    </p>
                    <button
                      className="btn edit-btn"
                      onClick={() => navigate(`/tournaments/${slug}/events/${selectedEvent._id}/edit`)}
                    >
                      ✏️ עריכה
                    </button>
                  </>
                )}
              </>
            )}
          </main>
        </div>
      )}
    </div>
  );
};

export default TournamentDetails;
